import React from 'react'
import PropTypes from 'prop-types'
import { Message, Icon, Image } from 'semantic-ui-react'

import withTransition from './with-transition'

const icons = {
  info: 'announcement',
  success: 'checkmark',
  error: 'remove',
  warning: 'warning circle'
}

const SemanticToast = props => {
  const { type, title, description, onClose, image } = props
  const hasImage = !! image
  const icon = props.icon || icons[type]

  return (
    <Message
      icon
      info={type === 'info'}
      success={type === 'success'}
      error={type === 'error'}
      warning={type === 'warning'}
      onDismiss={onClose}
      floating
    >
      {
        hasImage ?
        <Image spaced='right' size='mini' src={ image } /> :
        <Icon name={ icon } />
      }
      <Message.Content>
        <Message.Header>{ title }</Message.Header>
        { description }
      </Message.Content>
    </Message>
  )
}

SemanticToast.propTypes = {
  type: PropTypes.oneOf(['info', 'success', 'error', 'warning']).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  onClose: PropTypes.func
}

SemanticToast.defaultProps = {
  onClose: undefined
}

export default withTransition(SemanticToast)
